/**
 * Utilitário para detecção de IP do cliente seguindo prioridade de segurança.
 * 
 * Lógica de Prioridade:
 * 1. HTTP_CF_CONNECTING_IP (Cloudflare - Mais confiável)
 * 2. HTTP_X_FORWARDED_FOR (Primeiro IP da lista)
 * 3. REMOTE_ADDR (Conexão direta)
 * 
 * NOTA: Esta função é projetada para rodar no lado do servidor (Node.js/Express).
 * Em um ambiente puramente client-side (SPA), isso servirá como documentação
 * ou para uso em mocks.
 */

export const getClientIP = (req) => {
    if (!req) return null;

    // 1. Cloudflare (Mais confiável)
    const cfIP = req.headers['cf-connecting-ip'];
    if (cfIP) return cfIP;

    // 2. X-Forwarded-For (Proxies)
    const forwardedFor = req.headers['x-forwarded-for'];
    if (forwardedFor) {
        // Pega o primeiro IP da lista (o original do cliente)
        const ips = forwardedFor.split(',').map(ip => ip.trim());
        return ips[0];
    }

    // 3. Remote Address (Conexão Direta)
    return req.socket?.remoteAddress || req.connection?.remoteAddress || null;
};

/**
 * MOCK: Gera um IP aleatório para simulação no frontend
 */
export const generateMockIP = () => {
    return `${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`;
};
